export class BranchLocationOperatingHours {
  /** @type {Date} */
  open = new Date(0);
  /** @type {Date} */
  close = new Date(0);

  /** @type {string} */
  timeZone;
}

export class BranchLocation {
  /**
   * @type {string}
   */
  address;
  /**
   * @type {string}
   */
  city;

  /**
   * Key field
   *
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  name;

  /**
   * @type {string}
   */
  phone;

  /**
   * @type {string}
   */
  state;

  /**
   * @type {string}
   */
  zip;

  /**
   * @type {string}
   */
  headshot;

  /**
   * @type {string}
   */
  manager;

  /**
   * Optional. Overrides the "local {name} branch manager" wording on the PDP
   * contact card, e.g. "BCS representative" for a territory rep record.
   * @type {string|undefined}
   */
  title;

  /**
   * Optional. The real branch this record represents when the record is a
   * territory rep (e.g. Brownsville → "San Antonio"). Used where a true
   * branch name is needed (HubSpot nearest_branch). Falls back to `name`.
   * @type {string|undefined}
   */
  branch;

  /**
   * @type {string}
   */
  shopify;

  /** @type {BranchLocationOperatingHours} */
  operatingHours = new BranchLocationOperatingHours();

  /**
   *
   * @param {BranchLocationOperatingHours} operatingHours
   * @returns {BranchLocation}
   */
  updateOperatingHours(operatingHours) {
    this.operatingHours = operatingHours;
    return this;
  }

  toString() {
    return JSON.stringify(this);
  }

  static fromJSON(json) {
    const instance = new BranchLocation();
    Object.keys(json).forEach(key => {
      const normalizedKey = key.toLowerCase();
      if (instance.hasOwnProperty(normalizedKey)) {
        instance[normalizedKey] = json[key];
      }
    });
    return instance;
  }
}
